import { render, staticRenderFns } from "./masterproduct.vue?vue&type=template&id=56ccc609&"
import script from "./masterproduct.vue?vue&type=script&lang=js&"
export * from "./masterproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports